import ReplaceDialog from './ReplaceDialog';

export default ReplaceDialog;
